const formater = function(value, type = 'short') {
    if (type === 'short') {
        let formated_value = '';
        if (value < 1000) {
            formated_value = value;
        } else if (value >= 1000 && value < 1000000) {
            let temp_value = Math.floor(value / 1000);
            formated_value = `${temp_value.toString()}K`;
        } else {
            let temp_value = Math.floor(value / 1000000);
            formated_value = `${temp_value.toString()}M`;
        }

        return formated_value;
    } else if (type === 'splitter') {
        if (!value) return '0';

        let val = (value / 1).toFixed(0).replace('.', ',');
        return `${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
    } else if (type === 'full') {
        if (!value && value !== 0) return '0';
        // Format currency dengan titik sebagai pemisah ribuan, tanpa konversi K/M
        let val = (value / 1).toFixed(0).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
};

export default formater;
